import { render, staticRenderFns } from "./AdminFeedbackConnect.vue?vue&type=template&id=59fe83d1&scoped=true"
import script from "./AdminFeedbackConnect.vue?vue&type=script&lang=ts"
export * from "./AdminFeedbackConnect.vue?vue&type=script&lang=ts"
import style0 from "./AdminFeedbackConnect.vue?vue&type=style&index=0&id=59fe83d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fe83d1",
  null
  
)

export default component.exports